<template>
  <div
      id="tracking"
      style="z-index: 99;"
  >
    <div
        class="card deviceInfoT"
        :style="{ bottom: 0 }"
    >
      <b-card-body style="background: #fff;padding-bottom: 0px;margin-bottom: 0px;">
        <div>
          <div
              class="row"
              style="margin-top: 0;padding-left: 0;"
          >
            <div
                class="col-5 col-md-5"
                style="padding: 5px 0px; padding-right: 30px;"
            >
              <span style="font-size: 1.1rem;    color: #555;" />
              {{ getPopupInfo(selectedDevice).title }}
            </div>
            <div
                class="col-2"
                style="padding: 5px 0px;display: flex;bottom: 10px;"
            />
            <div
                class="col-5 col-md-5"
                style="text-align: left;padding: 5px 0px;line-height: 1.6rem;"
            >
              <span style="font-size: 0.8rem;">{{ selectedDevice }}</span>
            </div>
          </div>
<hr>
          <div
              class="row"
              style="height: 65px;"
          >
            <div
                class="col-4"
                style="padding: 5px;text-align: center;"
            >
              <span
                  v-if="getDeviceOnlineStatusCssClass(selectedDevice)!=='onlineSymbol'"
                  style="font-size: 1.5rem;color: gray;"
              >
                حرکت
              </span>
              <span
                  v-else-if="getPopupInfo(selectedDevice).serverStatus.terminalInfo.gpsTracking"
                  style="font-size: 1.5rem;color: green;"
              >
                حرکت
              </span>
              <span
                  v-else
                  style="font-size: 1.2rem;color:#e76c6c;"
              >توقف</span>
              - {{ sinceFromDevice(selectedDevice) }}
            </div>
            <div
                class="col-3"
                style="padding: 5px;text-align: center;"
            >
              <span style="width: 100%;display: block;">
                <v-icon
                    size="22"
                    color="#3597ef"
                    style="padding-left: 3px;"
                >mdi-speedometer</v-icon>
              </span>
              <div style="direction: ltr;">
                <span>
                  {{ getPopupInfo(selectedDevice).speed }}
                </span>
                <span style="">
                  km/h
                </span>
              </div>
            </div>
            <div
                class="col-2"
                style="padding: 5px;text-align: center;"
            >
              <span style="width: 100%;display: block;">
                <v-icon
                    size="22"
                    color="#3597ef"
                    style="padding-left: 3px;"
                >mdi-satellite-uplink</v-icon>
              </span>
              <span style="">
                {{ getPopupInfo(selectedDevice).serverInfo.satCntActive }}
              </span>
            </div>
            <div
                class="col-3"
                style="padding: 5px;text-align: center;"
            >
              <span style="width: 100%;display: block;">
                <v-icon
                    size="22"
                    color="#3597ef"
                    style="padding-left: 3px;"
                >mdi-signal</v-icon>
              </span>
              <span style="font-size: 0.6rem;">
                {{ getPopupInfo(selectedDevice).serverStatus.gsmSigStrength }}
              </span>
            </div>

          </div>
        </div>

      </b-card-body>
    </div>

    <div dir="ltr">
      <l-map
          id="trackingMap"
          ref="trackingMap"
          dir="ltr"
          :zoom="zoom"
          :center="center"
          :min-zoom="5"
          :max-bounds="[[24.5, 44.0], [40.0, 63.5]]"
          :max-bounds-viscosity="1.0"
          :options="{zoomControl: true,preferCanvas: true}"
      >
        <l-control-layers position="bottomleft" />
        <l-tile-layer
            v-for="tileProvider in tileProviders"
            :key="tileProvider.name"
            :name="tileProvider.name"
            :visible="tileProvider.visible"
            :url="tileProvider.url"
            :attribution="tileProvider.attribution"
            :subdomains="tileProvider.subdomains"
            layer-type="base"
        />
        <v-rotated-marker
            v-for="(marker, imei) in mapMarkers"
            :key="imei"
            ref="marker"
            :visible="marker.visible"
            :lat-lng="marker.latlng"
            :rotation-angle="marker.rotationAngle"
            :icon="marker.state === 'myLocation' ? myLocationIcon: marker.state === 'start' ? StartMoveIcon : marker.state === 'end' ? EndMoveIcon : marker.state === 'stop' ? StopMoveIcon : mapCarIcon[imei]"
        >

          <LTooltip
              v-if="isMobile"
              :options="{
              interactive: false,
              permanent: true,
              opacity: 1,
              direction: 'top',
              offset: [0,-10]
            }"
          >
            <span
                v-if="getDeviceOnlineStatusCssClass(imei)!=='onlineSymbol'"
                style="color:gray;cursor:pointer"
            >{{ getPopupInfo(imei).title }}</span>
            <span
                v-else-if="getFixDeviceInfo(getPopupInfo(imei)).serverStatus.terminalInfo.gpsTracking"
                style="color:green;cursor:pointer"
            >{{ getPopupInfo(imei).title }}</span>
            <span
                v-else
                style="color:#e76c6c;cursor:pointer"
            >{{ getPopupInfo(imei).title }}</span>
          </LTooltip>

        </v-rotated-marker>
        <l-polyline
            :lat-lngs="polyline.latlngs"
            :color="polyline.color"
        />
      </l-map>
    </div>
  </div>
</template>

<script>
import jalalimoment from 'jalali-moment'

import {
  BCard, BCardBody, BCardText, BLink, BButton, BFormInput, BButtonGroup, BFormGroup, BFormSelect, BFormSelectOption,
  BProgress, BProgressBar, BForm,
} from 'bootstrap-vue'
import {
  LMap, LTileLayer, LMarker, LControlZoom, LPolyline, LPopup, LControlLayers, LTooltip,
} from 'vue2-leaflet'
import Vue2LeafletRotatedMarker from 'vue2-leaflet-rotatedmarker'
import 'leaflet-routing-machine'
import 'leaflet/dist/leaflet.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
import Vue from 'vue'
import deviceService, { DeviceService } from '@/services/device.service'
import router from '@/router'
import Device from '@/models/device'
import Config from '../../../config'
import { getUserData } from '@/auth/utils'
import UserService from '@/services/user.service'

const LeafIcon = L.Icon.extend({
  options: {
    shadowSize: [30, 40],
    iconAnchor: [30, 18],
    shadowAnchor: [2, 42],
    popupAnchor: [-3, -20],
    iconSize: [60, 36],
  },
})
const myLeafIcon = L.Icon.extend({
  options: {
    shadowSize: [30, 40],
    iconAnchor: [18, 18],
    shadowAnchor: [18, 18],
    popupAnchor: [-3, -40],
    iconSize: [36, 36],
  },
})
const PinLeafIcon = L.Icon.extend({
  options: {
    shadowSize: [30, 40],
    iconAnchor: [23, 70],
    shadowAnchor: [18, 18],
    popupAnchor: [-3, -40],
    iconSize: [46, 75],
  },
})

export default {
  components: {
    BProgress,
    BCard,
    BCardBody,
    BLink,
    BButton,
    LMap,
    LTooltip,
    LTileLayer,
    LPolyline,
    LMarker,
    LPopup,
    LControlZoom,
    LControlLayers,
    datePicker: VuePersianDatetimePicker,
    BForm,
    'v-rotated-marker': Vue2LeafletRotatedMarker,
  },
  data() {
    return {
      map: {},
      search: '',
      lastAngle: 0,
      options: Config.carTypes,
      device: new Device('', '', '', '', '', '', '', '', '', ''),
      timer: null,
      speed: 0,
      address: null,
      tileProviders: [
        {
          name: 'Map.ir',
          visible: true,
          attribution: '© Map.ir',
          url: `${Config.mapir.tileUrl}?x-api-key=${Config.mapir.apiKey}`,
        },
        {
          name: 'OpenStreetMap',
          visible: false,
          attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
          url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        },
      ],
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 5,
      // Iran position
      center: [32.4207, 53.6830],
      mapMarkers: {},
      listLimitDevice: {},
      historySideBarVisible: false,
      mapHistoryDateFromFormatted: '',
      mapHistoryTimeStart: '00:00',
      mapHistoryTimeEnd: '23:59',
      mapHistoryTimesSelected: {},
      isMobile: Vue.prototype.$functions.isMobile(),
      selectedDevice: this.$mobileSelectedDevices[0],
      selectedImei: Vue.prototype.$selectDeviceTracking,
      polyline: {
        latlngs: [],
        color: 'red',
      },
      mapCarIcon: new LeafIcon({
        iconUrl: require('@/assets/images/pins/cars/car.png'),
      }),
      myLocationIcon: new myLeafIcon({
        iconUrl: require('@/assets/images/pins/myloc.png'),
      }),
      StartMoveIcon: new PinLeafIcon({
        iconUrl: require('@/assets/images/pins/startmarker-min.png'),
      }),
      EndMoveIcon: new PinLeafIcon({
        iconUrl: require('@/assets/images/pins/endmarker-min.png'),
      }),
      StopMoveIcon: new PinLeafIcon({
        iconUrl: require('@/assets/images/pins/stopmarker-min.png'),
      }),
      newtitle: '',
      smsconfigtext: 'SERVER,0,s1.4-rah.com,4000,0#',
      items: [
        { title: 'تغییر نام خودرو', icon: 'mdi-account-edit', action: 'modal-change-name' },
        { title: 'تغییر نوع خودرو', icon: 'mdi-car', action: 'modal-change-category' },
        { title: 'تغییر سیمکارت', icon: 'mdi-sim-alert', action: 'modal-change-sim' },
        { title: 'ارسال تنظیمات سرور', icon: 'mdi-apple-keyboard-shift', action: 'modal-send-sms' },
      ],
    }
  },
  created() {

    this.QXUpdateFirebaseData()
    this.$vuetify.rtl = true
    this.showMarkers()
    this.checkOnlineStatus()
    this.doAction()
  },
  mounted() {
    setTimeout(() => { this.$forceUpdate() }, 3000)
    setTimeout(() => { this.$forceUpdate() }, 6000)
    this.$root.$on('forceUpdate', payload => {
      if (payload.event === 'socket.devicePosition') {
        if ('imei' in payload.data) {
          // برای غیر موبایل همیشه true هست و برای حالت موبایل
          // بررسی می شود که در صورت وجود در لیست نمایش دهد
          //  if (Vue.prototype.$functions.checkImeiInSelectedList(payload.data.imei)) {
          this.addUpdateMarker(payload.data)
          this.$forceUpdate()
          //  }
        }
      }
    })
  },
  methods: {
    QXUpdateFirebaseData() {
      UserService.updateFirebaseDataIfNeeded({})
    },

    showMarkers() {
      // console.log(this.selectedImei)
      const index = Vue.prototype.$functions.getDeviceIndex(this.selectedImei)
      if (index === -1) return
      const device = Vue.prototype.$devices[index]
      if (!device || !device.serverInfo) return
      const coords = Vue.prototype.$functions.getLatLngFromServerInfo(device.serverInfo)
      if (!coords) return
      const data = {
        latitude: coords.lat,
        longitude: coords.lng,
        imei: device.imei,
      }
      const deviceInfo = Vue.prototype.$functions.getDeviceInfo(data.imei)
      if (typeof this.options[deviceInfo.category] === 'undefined') {
        deviceInfo.category = 0
      }
      this.mapCarIcon[device.imei] = new LeafIcon({
        // eslint-disable-next-line global-require,import/no-dynamic-require
        iconUrl: require(`@/assets/images/pins/cars/${this.options[deviceInfo.category].src}.png`),
      })
      this.addUpdateMarker(data)
      this.$forceUpdate()
    },
    getFixDeviceInfo(device) {
      return Vue.prototype.$functions.fixDeviceInfo(device)
    },
    getDeviceOnlineStatusCssClass(imei) {
      try {
        return Vue.prototype.$devices[Vue.prototype.$functions.getDeviceIndex(imei)].onlineStatus
      } catch (e) {
        return false
      }
    },
    calcAngle(cx, cy, ex, ey) {
      const dy = ey - cy
      const dx = ex - cx
      // range (-PI, PI]
      let theta = Math.atan2(dy, dx)
      // rads to degs, range (-180, 180]
      theta *= 180 / Math.PI
      // if (theta < 0) theta = 360 + theta; // range [0, 360)
      return theta
    },
    getMyLocation() {
      // additionally, supplying options for fine-tuning, if you want to
      const options = {
        enableHighAccuracy: true,
        // time in millis when error callback will be invoked
        timeout: 5000,
        // max cached age of gps data, also in millis
        maximumAge: 0,
      }
      return new Promise(((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(
            pos => { resolve(pos) },
            err => { reject(err) },
            options,
        )
      }))
    },
    onMobileMapShareCarPosition() {
      if (this.selectedDevice.length <= 0) {
        return
      }
      const deviceInfo = this.getPopupInfo(this.selectedDevice)
      if (!deviceInfo || !deviceInfo.serverInfo) return
      const coords = Vue.prototype.$functions.getLatLngFromServerInfo(deviceInfo.serverInfo)
      if (!coords) return
      const sh = `https://www.google.com/maps/search/?api=1&query=${coords.lat},${coords.lng}`
      if (navigator.share) {
        navigator.share({
          title: 'چهارراه',
          text: 'موقعیت خودرو من',
          url: sh,
        }).then(() => console.log('Successful shared.'))
            .catch(error => console.log('Error sharing: ', error))
      } else {
        window.open(
            sh,
            '_blank', // <- This is what makes it open in a new window.
        )
      }
      // window.location.href = `geo:${parseFloat(deviceInfo.serverInfo.latitude.$numberDecimal)},${parseFloat(deviceInfo.serverInfo.longitude.$numberDecimal)}`
    },
    async onMobileMapSetMyLocation() {
      const position = await this.getMyLocation()
      if ('coords' in position) {
        const data = {
          imei: '123456', state: 'myLocation', latitude: position.coords.latitude, longitude: position.coords.longitude,
        }
        this.addUpdateMarker(data)
        this.setMapCenterAndZoom([data.latitude, data.longitude], 16)
      } else {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'پیام',
            text: 'دسترسی به موقعیت مکانی شما ممکن نیست.',
            icon: 'XIcon',
            variant: 'warning',
          },
        })
      }
    },
    timeHistory(unixTime) {
      // بررسی مقادیر نامعتبر
      if (!unixTime || unixTime < 1000) return ''
      return this.$functions.unixToPersianDate(unixTime)
    },
    sinceFrom(unixTime) {
      if (!unixTime || unixTime < 1000) {
        return this.$t('Unknown')
      }
      const time = Vue.prototype.$functions.time()
      return this.$functions.timeSince(unixTime > time ? time : unixTime)
    },
    sinceFromDevice(imei) {
      const d = Vue.prototype.$functions.fixDeviceInfo(Vue.prototype.$functions.getDeviceInfo(imei))
      if (!d || !d.serverInfo) return this.$t('Unknown')
      const servertime = d.serverInfo.servertime || 0
      const statusServertime = d.serverStatus?.servertime || 0
      const lastContact = Math.max(servertime, statusServertime)
      if (!lastContact || lastContact < 1000) return this.$t('Unknown')
      return this.sinceFrom(lastContact)
    },
    checkOnlineStatus() {
      clearInterval(Vue.prototype.$timer)
      Vue.prototype.$timer = setInterval(() => {
        this.$socket.emit('devicesOnlineTime', {})
      }, 20000)
    },
    doAction() {
      switch (this.$route.params.action) {
        case 'history':
          this.onMobileMapShowHistoryBar()
      }
    },
    getMarkerImei(index) {
      if (this.isMobile && this.selectedImei) {
        return this.selectedImei
      }
      return index
    },
    async getAddress() {
      const deviceInfo = Vue.prototype.$functions.getDeviceInfo(this.selectedDevice)
      if (!deviceInfo || !deviceInfo.serverInfo) return
      const coords = Vue.prototype.$functions.getLatLngFromServerInfo(deviceInfo.serverInfo)
      if (!coords) return
      this.address = await Vue.prototype.$functions.getFullAddress({
        latitude: coords.lat,
        longitude: coords.lng,
      }, this.selectedDevice)
    },
    getPopupInfo(index) {
      if (typeof index === 'undefined') {
        return false
      }
      return Vue.prototype.$functions.fixDeviceInfo(Vue.prototype.$functions.getDeviceInfo(this.getMarkerImei(index)))
    },
    setMapCenterAndZoom(center, zoom) {
      this.$nextTick(() => {
        if (this.$refs.trackingMap) {
          if (zoom) {
            this.$refs.trackingMap.setZoom(zoom)
          }
          this.$refs.trackingMap.setCenter(center)
        }
      })

    //   this.$refs.map.mapObject.setView(center, zoom)
    },
    isVisibleMarker(imei) {
      if (this.selectedImei === imei) {
        return true
      }
      return false
    },
    async addUpdateMarker(marker) {
      const data = marker

      if (typeof data.imei === 'undefined') {
        return
      }
      if (typeof data.imei === 'undefined' || typeof data.latitude === 'undefined' || typeof data.longitude === 'undefined') {
        data.latitude = 0
        data.longitude = 0
        return
      }
      if (data.imei in this.mapMarkers && this.mapMarkers[data.imei]) {
        this.lastAngle = this.calcAngle(this.mapMarkers[data.imei].latlng[0], this.mapMarkers[data.imei].latlng[1], data.latitude, data.longitude) + 90
        if (this.lastAngle === 90) {
          this.lastAngle = this.mapMarkers[data.imei].rotationAngle
        }
      } else {
        this.lastAngle = Math.floor(Math.random() * (180 + 1))
      }

      if (this.isMobile && this.selectedImei === data.imei) {
        this.setMapCenterAndZoom([data.latitude, data.longitude], 18)
      }
      this.speed = data.speed
      if (data.speed === '' || data.speed == null) this.speed = 0

      this.mapMarkers[data.imei] = {
        // علاوه بر اینکه باید برای نمایش انتخاب شده باشد اگر
        // مقادیر مختصاتی نا معتبر داشته باشد هم نباید نمایش داده شود زیرا
        // نقطه نمایش پرت خواهد بود و نامرتبط
        visible: this.isVisibleMarker(data.imei),
        // visible: data.visible,
        latlng: [data.latitude, data.longitude],
        rotationAngle: this.lastAngle,
      }
      this.$forceUpdate()
    },
  },
}
</script>

<style>
[dir=rtl] * {
  font-family: Vazir;
}

[dir=rtl] .leaflet-zoom-animated {
  transform-origin:   0% 0% !important;
  -webkit-transform-origin:   0% 0% !important;
  -ms-transform-origin:   0% 0% !important;
}

[dir=rtl] .leaflet-marker-icon {
  transform-origin: center center 0px !important;
}

[dir=rtl] .leaflet-pane, [dir=rtl] .leaflet-tile, [dir=rtl] .leaflet-marker-icon,
[dir=rtl] .leaflet-marker-shadow, [dir=rtl] .leaflet-tile-container, [dir=rtl] .leaflet-pane > svg,
[dir=rtl] .leaflet-pane > canvas, [dir=rtl] .leaflet-zoom-box, [dir=rtl] .leaflet-image-layer, [dir=rtl]
.leaflet-layer {
  right: unset !important;
}

.nodiplay .content-header{
  display: none !important;
}
.nodiplay .content-body{
  margin: -47px -27px !important;
}

[dir=rtl] #trackingMap {
  width: calc( 100vw - 400px );
  height: calc( 100vh - 60px );
  direction: ltr !important;
  text-align: left !important;
  padding: 0 !important;
  margin: 0 !important;
  top: 49px !important;
  right: 400px !important;
  position: absolute;
}

#tracking .deviceRow {
  margin-bottom: 4px;
  width: 100%;
  padding: 5px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24);
  transition: all 0.3s cubic-bezier(.25,.8,.25,1);
  border-radius: 5px;
  cursor: pointer;
  margin-bottom: 7px;
}

#tracking .deviceRow:hover {
  box-shadow: 0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23);
}

.deviceInfo .card-body {
  padding-top: 8px !important;
}
#tracking .card-body {
  padding-top: 0;
  /*
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important;
  */

}

.vpd-input-group input {
  border-radius: 0;
  text-align: center;
}

.vpd-input-group label {
  margin-bottom: 0 !important;
}
  [dir=rtl] .deviceInfoT {
  z-index: 998;
  width: 400px;
  overflow-y: hidden;
  position: absolute;
  border-radius: 0;
  background: #f7f7f7;
  box-shadow: 0 0 15px rgba(0,0,0,0.55);
  clip-path: inset(0px -15px 0px 0px);
  margin-bottom: 0;
}
.deviceRow {
  background: #fff;
}

.collapse .card-body{
  padding-left: 0.3rem !important;
  padding-right: 0.3rem !important;
}
@media (max-width: 767px) {
  [dir=rtl] #trackingMap {
    width: 100vw;
    height: calc( 100% - 55px );
    direction: ltr !important;
    text-align: left !important;
    padding: 0 !important;
    margin: 0 !important;
    top: 60px !important;
    position: absolute;

    right: inherit  !important;
    left: 0 !important;
  }
  [dir="rtl"] .devicesSideBar , [dir="rtl"] .deviceInfo , [dir="rtl"] .deviceInfoT {
    width: 100%;
  }
  [dir="rtl"] .deviceInfoT {
    background: #eee;
    height: 102px;
    right: 0;
  }
  .leaflet-bottom{
    bottom: unset !important;
    top: 40px;
  }
  .leaflet-control-zoom{
    top: 70px;
  }
  .leaflet-control-zoom a{
    color: gray;
  }
  [dir="rtl"] #tracking .v-data-table > .v-data-table__wrapper > table > tbody > tr > td{
    height: 70px !important;;
  }
}

.onlineSymbol, .offlineSymbol {
  height: 6px;
  width: 6px;
  border-radius: 50%;
  display: inline-block;
}

.onlineSymbol {
  background-color: #39e340;
}

.offlineSymbol {
  background-color: #b5b5b5;
}

.mobileOnMapHint {
  position: absolute;
  z-index: 999;
  background: rgba(100, 121, 128, 0.67);
  opacity: 0.9;
  border-radius: 5px;
  padding: 3px 6px 3px 6px;
  color: white;
  font-size: 1rem;
}

.mobileOnMapHintBtns {
  background: none;
}

.mobileOnMapHint button {
  height: 32px;
  width: 32px;
  padding: 0;
  font-size: 1.1rem;
  background: rgb(72, 128, 147) !important;
}

.mobileOnMapHistoryBtn {
  border-radius: 3px;
  padding: 0;
  opacity: 0.8;
  background: unset;
  right: 10px;
  bottom: 50px
}

.mobileOnMapHistoryBtn button {
  text-align: center;
  color: #eee;
  background: #5113db;
}

[dir=rtl] .mobileOnMapHintHistoryTime {
  bottom: 100px;
  left: 10px;
}
[dir=rtl] .mobileOnMapHintHistorySpeed {
  bottom: 100px;
  right: 10px;
}

[dir=rtl] .mobileOnMapHintCrosshairBtn {
  top: 32px;
  left: 5px;
  background: #fff;
  padding: 0px;
  border: 2px solid #d0cfcf;
}

[dir=rtl] #tracking .addDeviceBtn {
  height: 37px;
  width: 38px;
  z-index: 999;
  padding: 0
}
[dir] .btn-secondary:active{
  background-color: unset !important;
}
[dir=rtl] .playBtn {
  cursor: pointer;
  background: #ea121200 !important;
  border: 0px !important;
  top: 10px;
  left: 15px;
  z-index: 999;
  padding: 0
}
[dir=rtl] .closeBtn {
  height: 25px;
  width: 25px;
  position: absolute;
  right: 10px;
  top: 8px;
  z-index: 999;
  padding: 0
}

.leaflet-control-attribution {
  display: none;
}

.vpd-wrapper {
  z-index: 999 !important;
}
.rounded-circle{
  color: #fff !important;
}
#tracking .vpd-icon-btn{
  display: none !important;
}

[dir="rtl"] .v-input--selection-controls__ripple{

}
.v-menu{
  display: block !important;
}

.v-menu__content {
  font-size: 12px !important;
  opacity: 1 !important;
  background: #fff !important;
  box-shadow: 0 3px 14px rgba(0,0,0,0.4);
}

[dir] .leaflet-tooltip{
  padding: 1px 3px !important;
  border-radius: 8px;
}

</style>
